// used for injecting variable span tooltips into html
import parse from "html-react-parser";

export default function renderHtmlString(str) {
  return typeof str === "string" && /</.test(str) ? parse(str) : str;
}
